import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/vercel/path0/src/components/i18n/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellPageChrome"] */ "/vercel/path0/src/components/layout/app-shell/AppShellPageChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignQuizGame"] */ "/vercel/path0/src/features/campaign-quiz/CampaignQuizGame.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignQuizPageView"] */ "/vercel/path0/src/features/campaign-quiz/CampaignQuizPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignQuizRating"] */ "/vercel/path0/src/features/campaign-quiz/CampaignQuizRating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignSignupLink"] */ "/vercel/path0/src/features/campaign-quiz/CampaignSignupLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampaignTrackedLink"] */ "/vercel/path0/src/features/campaign-quiz/CampaignTrackedLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/application-utilities.css");
